import React from "react";
import { useTranslation } from "react-i18next";
import Items from "./Items";
import styles from "../NotesPage.module.scss";
const List = ({ notes, label, setNotes }) => {
  const { t } = useTranslation('common');
  return (
    <>
      <h2>{label}</h2>
      <div className={styles["notes-list"]}>
        {notes.length === 0 ? (
          <p className={styles["notes-list__empty-message"]}>{t('notes.no_notes')}</p>
        ) : (
          notes.map((note) => (
            <Items action={setNotes} key={note.id} {...note} />
          ))
        )}
      </div>
    </>
  );
};

export default List;
